function migrateTo3(state: any) {
  const source = state.login?.appUser ? 'app' : 'web';
  return { ...state, flow: { ...state.flow, source } };
}

export default migrateTo3;
